// Extrai mensagem de erro segura da API (evita passar objetos/arrays para o toast)
export const getApiError = (error, fallback = 'Ocorreu um erro') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => {
        if (typeof d === 'string') return d;
        const field = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : '';
        return d?.msg ? (field ? `${field}: ${d.msg}` : d.msg) : '';
      })
      .filter(Boolean);
    if (msgs.length) return msgs.join(' | ');
  }
  if (detail && typeof detail === 'object' && detail.msg) return String(detail.msg);
  if (error?.message === 'Network Error') return 'Erro de conexão com o servidor';
  return fallback;
};
